import { DateRangeRounded } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import apiService from '../../api/ApiService';
import { paginateCount } from '../../api/helper';
import {addTohistories} from '../../redux/slices/adminSlice'
import { useDispatch, useSelector } from 'react-redux';
import { calculateDetails } from '../../pages/SingleDam';
const moment=require('moment-jalaali')

const useHistory = (flag) => {
  const dispatch=useDispatch()
    const {currentAdmin,data,detailStatusList}=useSelector(state=>state.p.admin)
    const [selectedDayRange, setSelectedDayRange] = useState({
      from: null,
      to: null
    });
    const [total,setTotal]=useState(1)
    const [importanceLevel,setImportancelevel]=useState(null)
    const [importanceList,setImportanceList]=useState([])

    const [page,setPage]=useState(0)
    const [SData,setSdata]=useState({})
    const {id}=useParams()
    const [value, setValue] = useState('0');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getImportanceList=async()=>{
    const res=await apiService.getImportanceLevelList()
    setImportanceList(res.data.data)
}

    const getData=async()=>{
  
      let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
  
  
      let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
  
        const data=JSON.stringify({
          "skip": page?(page-1)*paginateCount:0,
          "take": paginateCount,
          "fromDate": selectedDayRange.from?geregorian1:null,
          "cattleIds":id?[id]:[],
          "farmId":currentAdmin?.id,
          "toDate": selectedDayRange.to?geregorian2:null,
          "entryUserId": null,
          "isReaded": value==1?true:false,
          "importanceLevel":importanceLevel==null?null:+importanceLevel
        })
        switch(flag){
        case 'cattleParameter':
            const res=await apiService.getCattleHistoryParameters(id,data)
            dispatch(addTohistories(res.data.data))
            setTotal(Math.ceil(res.data.totalCount/paginateCount))
        break;
        case 'sensorStatus':
            const res1=await apiService.getSensorHistory(id,data)
            dispatch(addTohistories(res1.data.data))
            setTotal(Math.ceil(res1.data.totalCount/paginateCount))
        break;
        case 'sensorParameter':
            const res3=await apiService.getSensorHistoryParameters(id,data)
            dispatch(addTohistories(res3.data.data))
            setTotal(Math.ceil(res3.data.totalCount/paginateCount))
        break;
        case 'cattleStatus':
          const res4=await apiService.getCattleHistory(data)
          dispatch(addTohistories(res4.data.data))
          setTotal(Math.ceil(res4.data.totalCount/paginateCount))
        break;
        }
  
    }
    const handlePage = (event, value) => {
      setPage(value);
    };
    
    useEffect(()=>{
      if(selectedDayRange.to!==null){
        if(page===0){
          getData()
        }
        setPage(0)
      }
    },[selectedDayRange.to])
    useEffect(()=>{
    
      if(importanceLevel!==null){
        if(page===0){
          getData()
        }
        setPage(0)
      }
    
  },[importanceLevel])
  useEffect(()=>{
    getImportanceList()
  },[])
    useEffect(()=>{
      getData()
    },[page,value])
    const renderCustomInput = ({ ref }) => (
      <>
        
        <input
      name="birth"
      autoComplete="off"
      ref={ref} // necessary
      placeholder='تاریخ تولد'
      value={selectedDayRange.from?`از ${selectedDayRange.from?.year}/${selectedDayRange.from?.month}/${selectedDayRange.from?.day}  تا  ${selectedDayRange.to?.year?selectedDayRange.to?.year:'-'}/${selectedDayRange.to?.month?selectedDayRange.to?.month:'-'}/${selectedDayRange.to?.day?selectedDayRange.to?.day:'-'}`:''}
      className="opop2" // a styling class
    />
    <label for="" class="labelSS9"><DateRangeRounded/> فیلتر بر اساس بازه زمانی </label>
    
      </>
    )
  return {
        total,page,handlePage,data,SData,setSdata,selectedDayRange, setSelectedDayRange,renderCustomInput,value,setValue,handleChange,setImportancelevel,importanceLevel,importanceList
  }
}

export default useHistory
